import React,{Component} from 'react'
import demoimage from '../images/demopgone.jpeg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { GooglePlayButton } from "react-mobile-app-button";

const Home = () => {
  return (
    <Container>
      <Row className='top-section'>
        <Col sm={5} className='headingsection'>
          <div className='headingsection'>
          <h1 className='heading'>Talk to your&nbsp;
          <span className='greentext'>
          personal friend</span></h1>
          <p className='tagline'>Chat and talk with an array of AI friends for engaging, insightful conversations like never before. Install now!</p>
          </div>
      <p className='store-buttons'>
      <GooglePlayButton
        url={'APKUrl'}
        theme={"dark"}
        className={"custom-style"}
      
      /></p>

        </Col>
        <Col sm={4}>
          <img src={demoimage}></img>
        </Col>
      </Row>
    </Container>


    
  )
}

export default Home